import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Switch as SerendieSwitch } from "@serendie/ui";

export class Switch extends BaseComponent<ISwitchProps, ISwitchState>
{
    public render(): JSX.Element
    {
        return <SerendieSwitch
            {...this.props}
        />
    }
}

export type ISwitchProps = React.ComponentProps<typeof SerendieSwitch>;
export interface ISwitchState { }
